import { useCallback, useRef } from 'react';

import { App } from 'antd';
import { useTranslation } from 'react-i18next';

import appI18n from '../../../config/i18n';

const I18N = 'scenes.leads.components.detail_lead_modal.tags';

/**
 * Guards leaving a view with unsaved edits: `confirmDiscard(proceed)` runs
 * `proceed` right away, or only after the user confirms discarding. The dirty
 * flag is a ref because it is only read at the moment of leaving.
 */
export const useConfirmDiscard = () => {
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const { modal } = App.useApp();
  const dirtyRef = useRef<boolean>(false);

  const setDirty = useCallback((dirty: boolean) => {
    dirtyRef.current = dirty;
  }, []);

  const confirmDiscard = (proceed: () => void) => {
    if (!dirtyRef.current) {
      proceed();
      return;
    }
    modal.confirm({
      title: t(`${I18N}.discard_title`),
      content: t(`${I18N}.discard_content`),
      okText: t(`${I18N}.discard_ok`),
      cancelText: t(`${I18N}.discard_cancel`),
      onOk: proceed,
    });
  };

  return { setDirty, confirmDiscard };
};
